export const INIT = 'init'
export const CLOSE_MODAL_IFRAME = 'close_modal_iframe'
export const OPEN_CHECKOUT_IFRAME = 'open_checkout_iframe'
